import { configureStore } from "@reduxjs/toolkit";

import { userReducer } from "./slices/userSlice";
import { cartReducer } from "./slices/cartSlice";
import { scrumReducer } from "./slices/scrumSlice";
import { brandReducer } from "./slices/brandSlice";
import { ratingReducer } from "./slices/ratingSlice";
import { productReducer } from "./slices/productSlice";
import { categoryReducer } from "./slices/categorySlice";
import { notificationReducer } from "./slices/notificationSlice";

const store = configureStore({
  reducer: {
    cart: cartReducer,
    users: userReducer,
    brands: brandReducer,
    ratings: ratingReducer,
    scrumboard: scrumReducer,
    products: productReducer,
    categories: categoryReducer,
    notifications: notificationReducer
  },
  devTools: process.env.NODE_ENV !== "production"
});

export default store;
